import PropTypes from 'prop-types'

import DynamicRendering from '@adv-mt/mt-perf-dynamic-rendering'

import {BASE_CLASS, DEFAULT_EMPTY_MULTIPLE_VALUE, DEFAULT_EMPTY_OPTIONS, NO_OP} from '../../config.js'
import {FilterBasicLegacyMultiSelectionItem} from '../MultiSelection/index.js'

const ITEM_HEIGHT = 56
const GROUP_HEIGHT = 146

const ItemPlaceholder = () => <div style={{height: `${ITEM_HEIGHT}px`}} />
const Grouplaceholder = () => <div style={{height: `${GROUP_HEIGHT}px`}} />

const FilterBasicLegacyMultiSelectionNested = ({
  fieldFilter,
  onChange = NO_OP,
  options = DEFAULT_EMPTY_OPTIONS,
  showAllSelectionsField = true,
  values = DEFAULT_EMPTY_MULTIPLE_VALUE
}) => {
  const handleSelectDefaultValue = () => onChange([])

  const handleSelectGroupItem = ({nestedItems}) => {
    const nestedItemsIds = nestedItems.map(({id}) => id)

    const isPreviouslySelected = nestedItemsIds.every(id => values.includes(id))

    const newSelections = isPreviouslySelected
      ? values.filter(id => !nestedItemsIds.includes(id))
      : [...values, ...nestedItemsIds]

    onChange(newSelections)
  }

  const handleSelectedNestedItem = ({id}) => {
    const isPreviouslySelected = values.includes(id)
    return isPreviouslySelected ? removeCurrentSelectedItem({id}) : setNewSelections({id})
  }

  const setNewSelections = ({id}) => {
    const newSelections = [...values, id]
    onChange(newSelections)
  }

  const removeCurrentSelectedItem = ({id}) => {
    const cleanedCurrentSelections = values.filter(currentSelection => currentSelection !== id)
    onChange(cleanedCurrentSelections)
  }

  return (
    <div className={`${BASE_CLASS}-nestedList`}>
      {showAllSelectionsField && (
        <li className={`${BASE_CLASS}-nestedListFieldFilter`}>
          <FilterBasicLegacyMultiSelectionItem
            id={fieldFilter.id}
            isHighlighted
            isSelected={!values.length}
            label={fieldFilter.label}
            onChange={handleSelectDefaultValue}
          />
        </li>
      )}
      {options.map(({id, isDisabled, label, nestedItems}) => {
        const isSelected = nestedItems.every(({id}) => values.includes(id))

        return (
          <DynamicRendering placeholder={<ItemPlaceholder />} key={id}>
            <div key={id}>
              <li className={`${BASE_CLASS}-nestedListSectionWrapper is-sticky`}>
                <FilterBasicLegacyMultiSelectionItem
                  id={id}
                  isHighlighted
                  isDisabled={isDisabled}
                  isSelected={!isDisabled && isSelected}
                  label={label}
                  onChange={() => handleSelectGroupItem({nestedItems})}
                />
              </li>
              <DynamicRendering placeholder={<Grouplaceholder />}>
                <ul className={`${BASE_CLASS}-nestedListWrapper`}>
                  {nestedItems.map(({extendedInfo, icon, id, isHighlighted, label}) => {
                    const isSelected = values.includes(id)

                    return (
                      <DynamicRendering key={id} placeholder={<ItemPlaceholder />}>
                        <FilterBasicLegacyMultiSelectionItem
                          extendedInfo={extendedInfo}
                          icon={icon}
                          id={id}
                          isHighlighted={isHighlighted}
                          isSelected={isSelected}
                          label={label}
                          onChange={handleSelectedNestedItem}
                          key={id}
                        />
                      </DynamicRendering>
                    )
                  })}
                </ul>
              </DynamicRendering>
            </div>
          </DynamicRendering>
        )
      })}
    </div>
  )
}

FilterBasicLegacyMultiSelectionNested.displayName = 'FilterBasicLegacyMultiSelectionNested'
FilterBasicLegacyMultiSelectionNested.propTypes = {
  fieldFilter: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isDisabled: PropTypes.bool,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired
    })
  ),
  showAllSelectionsField: PropTypes.bool,
  values: PropTypes.array
}

export default FilterBasicLegacyMultiSelectionNested
